// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-jobGlossaryLink":"jobSearchDetail-jobGlossaryLink"};